var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCircleXmark(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M15.523 2.25c-3.515 0-6.703 1.875-8.484 4.875-1.734 3.047-1.734 6.75 0 9.75 1.781 3.047 4.969 4.875 8.484 4.875 3.47 0 6.657-1.828 8.438-4.875 1.734-3 1.734-6.703 0-9.75-1.781-3-4.969-4.875-8.438-4.875zm0 21.75c-4.312 0-8.25-2.25-10.406-6-2.156-3.703-2.156-8.25 0-12 2.156-3.703 6.094-6 10.406-6 4.266 0 8.204 2.297 10.36 6 2.156 3.75 2.156 8.297 0 12a11.91 11.91 0 01-10.36 6zM11.727 8.203a1.103 1.103 0 011.546 0l2.204 2.203 2.203-2.203c.468-.422 1.172-.422 1.593 0 .47.469.47 1.172 0 1.594L17.07 12l2.203 2.203c.47.469.47 1.172 0 1.594-.421.469-1.125.469-1.593 0l-2.203-2.203-2.204 2.203a1.027 1.027 0 01-1.546 0c-.47-.422-.47-1.125 0-1.594L13.93 12l-2.203-2.203c-.47-.422-.47-1.125 0-1.594z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCircleXmark);
export default ForwardRef;
